import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const certService = {
    getAllCerts,
    updateCertStatus,
    getCert,
    updateCert,
    createCert,
};

const MODULE = {
    CERT: 'rnd-product-registration-certs',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'Cert') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export async function getAllCerts(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            product: filter.product,
            name: filter.name,
            is_active: filter.isActive
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return await apiHelper(API_URL).get(`/${MODULE.CERT}`, requestOptions)
}


export function updateCertStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.CERT}/${data.id}`, requestOptions)
}

export function getCert(id) {
    return apiHelper(API_URL).get(`/${MODULE.CERT}/${id}`)
}

export function updateCert(data) {
    const formData = new FormData();
    formData.append(`product_uuid`, data.productID);
    formData.append(`name`, data.name);
    formData.append(`_method`, 'PUT');

    if (data.file instanceof File) {
        formData.append(`file`, data.file);
    }

    return apiHelper(API_URL).post(`/${MODULE.CERT}/${data.id}`, formData)
}

export function createCert(data) {
    const formData = new FormData();
    formData.append(`product_uuid`, data.productID);
    formData.append(`name`, data.name);

    if (data.file instanceof File) {
        formData.append(`file`, data.file);
    }


    return apiHelper(API_URL).post(`/${MODULE.CERT}`, formData)
}